module.exports = __webpack_public_path__ + "img/cassette-vhs.4d49131a.svg";